/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowFigureASquareRightIcon16Light } from './ArrowFigureASquareRightIcon16Light';
import { ArrowFigureASquareRightIcon16Regular } from './ArrowFigureASquareRightIcon16Regular';
import { ArrowFigureASquareRightIcon16Solid } from './ArrowFigureASquareRightIcon16Solid';
import { ArrowFigureASquareRightIcon20Light } from './ArrowFigureASquareRightIcon20Light';
import { ArrowFigureASquareRightIcon20Regular } from './ArrowFigureASquareRightIcon20Regular';
import { ArrowFigureASquareRightIcon20Solid } from './ArrowFigureASquareRightIcon20Solid';
import { ArrowFigureASquareRightIcon24Regular } from './ArrowFigureASquareRightIcon24Regular';
import { ArrowFigureASquareRightIcon24Solid } from './ArrowFigureASquareRightIcon24Solid';
import { ArrowFigureASquareRightIcon32Regular } from './ArrowFigureASquareRightIcon32Regular';
import { ArrowFigureASquareRightIcon64Regular } from './ArrowFigureASquareRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowFigureASquareRightIcon16Light,
        regular: ArrowFigureASquareRightIcon16Regular,
        solid: ArrowFigureASquareRightIcon16Solid,
    },
    20: {
        light: ArrowFigureASquareRightIcon20Light,
        regular: ArrowFigureASquareRightIcon20Regular,
        solid: ArrowFigureASquareRightIcon20Solid,
    },
    24: {
        regular: ArrowFigureASquareRightIcon24Regular,
        solid: ArrowFigureASquareRightIcon24Solid,
    },
    32: {
        regular: ArrowFigureASquareRightIcon32Regular,
    },
    64: {
        regular: ArrowFigureASquareRightIcon64Regular,
    },
};
export var ArrowFigureASquareRightIcon = forwardRef('ArrowFigureASquareRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
